export const facebookStatisticsGroups = [
  {
    label: '',
    options: [
      {value: 'traffic', label: 'FB Кампания'},
      {value: 'source', label: 'FB Поток'},
      {value: 'campaign', label: 'Кампании'},
      {value: 'adset', label: 'Adset'},
      {value: 'ad', label: 'Ad'},
    ],
  },
];
